import { useState, useCallback } from 'react';
import { toast } from 'sonner';
import axios from 'axios';
import { getApiEndpoint } from '@/utils/ERPUtils';
import { Role } from '@/components/roles-modules/types';

import { logger } from '@/utils/logger';
export const useEditUserRoles = () => {
  const [availableRoles, setAvailableRoles] = useState<Role[]>([]);
  const [loadingRoles, setLoadingRoles] = useState(false);

  const fetchRoles = useCallback(async () => {
    try {
      setLoadingRoles(true);
      const rolesResponse = await axios.get(getApiEndpoint("GET_ALL_ROLES"))
      const rolesData = rolesResponse.data.message.data

      if (rolesResponse?.data.message.status === "error") throw Error(rolesResponse?.data.message.message);
      setAvailableRoles(rolesData || []);
    } catch (error) {
      logger.error('Error fetching roles:', error);
      toast.error('Failed to fetch roles');
      setAvailableRoles([]);
    } finally {
      setLoadingRoles(false);
    }
  }, []);

  return {
    availableRoles,
    loadingRoles,
    fetchRoles,
  };
};